import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DownloadIcon from 'components/v2/icons/DownloadIcon';
const FileDownload = ({ fileUrl, children, className }) => {
    return (React.createElement("a", { href: fileUrl, target: "_blank", rel: "noopener noreferrer", className: classnames('inline-block', className) },
        React.createElement("div", { className: "flex items-center space-x-1" },
            React.createElement(DownloadIcon, { className: "w-5 h-5" }),
            React.createElement("div", null, children))));
};
FileDownload.propTypes = {
    fileUrl: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
};
export default FileDownload;
